import Vue from 'vue';

Vue.filter('currency', (value, currency = 'EUR', locale = 'de-DE') => {
    if (value === null || value === undefined || isNaN(value)) return '';
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
});